/**
 * [mojdzial1006, paczka MD-KIT → właściciel MD-PRACA, projekt §2.2, §3.14–3.18] REJESTR — GRUPA „PRACA I ROZWÓJ”.
 *
 * Zadania, Tablica (lista tablic + tablica jako obiekt W TREŚCI `?tablica=ID`, D-8), Cele, Ocena i wdrożenie, Szkolenia.
 * `?zMoimi=1` POSZERZA listę o własne zadania / osobiste tablice (nazwa inna niż `?moje=1` startu — N-18), `?okresCelu=` to
 * okres celów (nazwa inna niż `?okres=` Aktywności — N-18). `komponent` = zaślepki z MD-KIT.
 */
import { GRUPY_MOJEGO_DZIALU, kreatoryMiejsca, miejsceZZakladki, obiektyMiejsca } from "./wspolne";

export const miejsceZadania = miejsceZZakladki("todo", {
    grupa: GRUPY_MOJEGO_DZIALU.praca,
    etykieta: "Zadania",
    zdanie: "Zadania Twoich ludzi: na dziś, zaległe i ukończone.",
    wzor: "S2",
    licznik: true,
    widoki: [
        { id: "do-zrobienia", etykieta: "Do zrobienia", licznik: true },
        { id: "wszystkie", etykieta: "Wszystkie" },
    ],
    filtry: ["stan", "priorytet", "kto", "jednostka", "grupuj", "zMoimi"],
    obiekty: obiektyMiejsca("zadanie"),
    kreatory: kreatoryMiejsca("dodaj-zadanie"),
    pasek: { szukajka: "Szukaj zadania…", akcjaGlowna: "Dodaj zadanie…", wiecej: ["Pobierz CSV…"] },
    glowa: { zdanieStanu: "4 na dziś · 2 zaległe · 12 aktywnych · 30 ukończonych w miesiącu" },
    zdarzeniaNaZywo: ["task-upserted", "task-removed"],
    slowa: ["zadania działu", "todo", "dni realizacji", "na dziś", "zaległe zadania"],
    komponent: () => import("../../../pages/mojDzial/miejsca/Zadania"),
});

export const miejsceTablica = miejsceZZakladki("kanban", {
    grupa: GRUPY_MOJEGO_DZIALU.praca,
    etykieta: "Tablica",
    zdanie: "Tablice zadań działu: kolumny, karty i terminy.",
    wzor: "S2 + obiekt w treści",
    filtry: ["zMoimi", "priorytet", "kto", "jednostka"],
    obiekty: obiektyMiejsca("tablica", "zadanieTablicy"),
    kreatory: kreatoryMiejsca("nowa-tablica"),
    pasek: { szukajka: "Szukaj karty…", wiecej: ["Nowa tablica…", "Pobierz CSV…", "Otwórz w module Kanban →"] },
    glowa: { zdanieStanu: "12 kart · 3 Twoich osób · 2 po terminie w kolumnach nieukończonych" },
    zdarzeniaNaZywo: ["kanban-board-changed"],
    slowa: ["kanban", "pełny kanban", "projekty działu", "tablica zadań", "karty zadań"],
    komponent: () => import("../../../pages/mojDzial/miejsca/Tablica"),
});

export const miejsceCele = miejsceZZakladki("cele", {
    grupa: GRUPY_MOJEGO_DZIALU.praca,
    etykieta: "Cele",
    zdanie: "Cele Twoich ludzi i działu: propozycje do decyzji, postęp i oceny.",
    wzor: "S2",
    licznik: true,
    widoki: [
        { id: "do-decyzji", etykieta: "Do decyzji", licznik: true },
        { id: "do-oceny", etykieta: "Do oceny", licznik: true },
        { id: "wszystkie", etykieta: "Wszystkie" },
    ],
    filtry: ["okresCelu", "poziom", "stan", "kto"],
    obiekty: obiektyMiejsca("cel"),
    kreatory: kreatoryMiejsca("przypisz-cel", "cel-dzialu"),
    pasek: { szukajka: "Szukaj celu lub osoby…", wiecej: ["Przypisz cel…", "Cel działu…"] },
    glowa: { zdanieStanu: "23 osoby · bez celów: 4 · średni postęp 58% · po terminie: 2" },
    zdarzeniaNaZywo: ["goal-upserted", "goal-removed"],
    slowa: ["cele zespołu", "propozycje celów", "ocena celów", "cele działu", "historia celów"],
    komponent: () => import("../../../pages/mojDzial/miejsca/Cele"),
});

export const miejsceOcena = miejsceZZakladki("ocena-pracownika", {
    grupa: GRUPY_MOJEGO_DZIALU.praca,
    etykieta: "Ocena i wdrożenie",
    zdanie: "Notatki o pracy, oceny wdrożeniowe i ścieżki kariery Twoich ludzi.",
    wzor: "S2",
    licznik: true,
    widoki: [
        { id: "do-zrobienia", etykieta: "Do zrobienia", licznik: true },
        { id: "wszyscy", etykieta: "Wszyscy" },
    ],
    filtry: ["jednostka", "stan", "kategoria"],
    obiekty: obiektyMiejsca("notatka", "sciezka"),
    kreatory: kreatoryMiejsca("wniosek-o-ocene", "dodaj-notatke"),
    pasek: { szukajka: "Szukaj osoby…" },
    glowa: { zdanieStanu: "2 oceny do wystawienia · 1 osiągnięcie czeka" },
    sekcje: [{ id: "sciezki", etykieta: "Ścieżki kariery zespołu — tabela" }],
    zdarzeniaNaZywo: ["career-changed", "hr-request-changed", "hr-notification"],
    dziennikWejscia: "MyDeptEvaluationPage",
    slowa: ["ocena pracownika", "ocena wdrożeniowa", "INS-ZKL-02", "notatki o pracy", "ścieżka kariery", "osiągnięcia"],
    komponent: () => import("../../../pages/mojDzial/miejsca/Ocena"),
});

export const miejsceSzkolenia = miejsceZZakladki("e-learning", {
    grupa: GRUPY_MOJEGO_DZIALU.praca,
    etykieta: "Szkolenia",
    zdanie: "Kursy przypisane Twoim ludziom: kto skończył, kto jest po terminie.",
    wzor: "S2",
    licznik: true,
    widoki: [
        { id: "wszystkie", etykieta: "Wszystkie" },
        { id: "po-terminie", etykieta: "Po terminie", licznik: true },
        { id: "obowiazkowe", etykieta: "Obowiązkowe" },
    ],
    filtry: ["stan", "kto", "jednostka"],
    obiekty: obiektyMiejsca("kurs"),
    pasek: { szukajka: "Szukaj kursu…", wiecej: ["Pobierz zapisy (CSV)…", "Otwórz E-learning →"] },
    glowa: { zdanieStanu: "9 kursów · ukończyło 41 z 63 zapisów · w trakcie 12 · wynik 82%" },
    sekcje: [{ id: "osoby", etykieta: "Osoby" }],
    zdarzeniaNaZywo: ["course-upserted", "course-removed"],
    slowa: ["e-learning", "kursy", "szkolenia zespołu", "kursy po terminie", "certyfikaty"],
    komponent: () => import("../../../pages/mojDzial/miejsca/Szkolenia"),
});

export const miejscaPracy = [miejsceZadania, miejsceTablica, miejsceCele, miejsceOcena, miejsceSzkolenia];

export default miejscaPracy;
